import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const EventVanTravel = () => {
  return (
    <>
      <Helmet>
        <title>How to Coordinate Group Travel for Special Events</title>
        <meta
          name="description"
          content="Learn how to coordinate group travel for special events using rental vans. Tips for planning routes, seating, logistics, and comfort."
        />
      </Helmet>
      <div className="bg-[#fff] w-full flex flex-col">
        <section
          className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
          style={{ backgroundImage: `url('../images/event-van-travel.jpg')` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
          <div className="relative z-10">
            <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
              How to Coordinate Group Travel for Special Events with a Rental Van
            </h1>

            <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faClock} className="w-4" />
                <p className="blog-publish-date">11/18/2025</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faComment} className="w-4" />
                <p className="blog-publish-date">12 Comments</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faBookmark} />
                <p className="blog-publish-date">1840 Views</p>
              </div>
            </div>
          </div>
        </section>

        <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
          <div className="mx-auto max-w-screen-md">
            <p className="pb-4 text-justify leading-7">
              Planning group travel for special events such as weddings, conferences, funerals, or corporate functions requires thoughtful coordination. One of the most effective solutions is renting a passenger van to simplify transportation, cut costs, and ensure guests arrive comfortably and on time.
            </p>

            <p className="pb-4 text-justify leading-7">
              JJ Van Rental specializes in providing vans for every type of special event. Whether you need transportation for guests flying in from out of town or shuttling attendees between hotels and venues, a rental van is a flexible and efficient option.
            </p>

            <p className="pb-4 text-justify leading-7">
              Start by estimating the number of passengers. Vans typically seat 8 to 15 passengers, so understanding your group size helps you choose the right vehicle. If you're organizing a large event, you may need multiple vans or trips, which can be coordinated through your rental provider.
            </p>

            <p className="pb-4 text-justify leading-7">
              Next, plan out pickup and drop-off logistics. JJ Van Rental offers delivery and collection of vans at airports, offices, or home addresses, making the process even more convenient. Be sure to communicate the full itinerary with your rental provider to ensure smooth transitions and on-time service.
            </p>

            <p className="pb-4 text-justify leading-7">
              Consider extras such as drivers (if you prefer not to assign someone from the group), GPS, and room for cargo or event materials. Events like weddings or corporate retreats often require additional luggage space or seating comfort, which should be factored into your rental decision.
            </p>

            <p className="pb-4 text-justify leading-7">
              Coordinating group travel with a rental van not only simplifies logistics but also builds a sense of community among your guests. With JJ Van Rental, you can expect reliable, professional service tailored to your event needs—making transportation one less thing to worry about.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <div className="max-w-screen-md mx-auto rounded-md px-4 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            {/* Tags */}
            <div className="flex flex-wrap gap-2">
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Group Travel</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Special Events</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Van Rentals</p>
            </div>

            {/* Social Buttons */}
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex items-center bg-[#42599E] px-4 py-2 rounded-lg text-white">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebook} className="mr-2" /> share
                </a>
              </div>
              <div className="flex items-center bg-[#55ACEE] px-4 py-2 rounded-lg text-white">
                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTwitter} className="mr-2" /> tweet
                </a>
              </div>
              <div className="flex items-center bg-[#34AF23] px-4 py-2 rounded-lg text-white">
                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> whatsapp
                </a>
              </div>
              <div className="flex items-center bg-[#0798CF] px-4 py-2 rounded-lg text-white">
                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} className="mr-2" /> linkedin
                </a>
              </div>
            </div>
          </div>

        </section>
      </div>
    </>
  );
};

export default EventVanTravel;